<app-doc-builder [hideList]=true [determinantMapById]="determinantMapById">
<div class="layer container-fluid px-5">
    <div class="row">
        <div class="col-12">            
            <div class="certificate-main-tabs d-flex">
                <div *ngIf="document" class="certificate-tab disabled foreground"><span class="highlight">{{ document.name }}</span></div>
                <div class="certificate-tab {{(activeTab === 'general' || document.isExternal) ? 'active-tab': ''}}" (click)="notifyTabChange('general')">
                    {{ 'cert.generalTab' | translate }}
                </div>
                <div *ngIf="document && !document.isExternal"
                    class="certificate-tab {{activeTab === 'certificate-form' ? 'active-tab': ''}}"
                    (click)="notifyTabChange('certificate-form')">
                    {{ 'cert.form' | translate }}
                </div>
                <div class="align-items-center d-flex ml-auto">
                    <tutorial-layer
                            *ngIf="document && document.tutorials && document.tutorials.general"
                            class="inpage-tutorial inline-tutorial-button"
                            title="{{ document.name }}"
                            [isClosed]="true"
                            [editorData]="document.tutorials.general"
                            (saveTutorial)="saveTutorial($event)">
                    </tutorial-layer>
                </div>
            </div>
            <div class="certificate-main-tabs-content">
                <div class="certificate-tab-content tab-general {{(activeTab === 'general' || document.isExternal) ? 'active-tab': ''}}">
                    <div class="certificate-tab-inner">
                        <div class="col-12 px-0" style="z-index:23; position: sticky; top: 2rem;">
                            <div class="row fields-group">
                                <div class="col-8">
                                    <div class="list-title d-flex w-100">
                                        <span class="field-required">
                                            {{ 'annexes.doc.name_placeholder' | translate }}
                                        </span>
                                    </div>
                                    <form class="form-controller">
                                        <input
                                            required
                                            class="form-control"
                                            type="text"
                                            name="documentName"
                                            [(ngModel)]="document.name"
                                            [rangeLength]="[2, 256]"
                                            minlength="2"
                                            maxlength="256"
                                            #fname="ngModel"
                                            placeholder="{{'Type a certicate name' | translate}}"
                                            (change)="saveDocument()" />
                                    </form>
                                    <p
                                        class="validation-error"
                                        *ngIf="fname.errors?.required && (fname?.dirty && fname?.touched)">
                                        {{ 'form.validate.required' | translate }}
                                    </p>
                                    <p
                                        class="validation-error"
                                        *ngIf="fname.errors?.rangeLength && (fname?.dirty && fname?.touched)">
                                        {{ 'form.validate.minLenght' | translate }} 2!
                                    </p>
                                    <p
                                        class="validation-error"
                                        *ngIf="fname.errors?.rangeLength && (fname?.dirty && fname?.touched)">
                                        {{ 'form.validate.maxLenght' | translate }} 256!
                                    </p>
                                </div>
                                <div class="col-4">
                                    <div class="list-title d-flex w-100">
                                        <span class="field-required">
                                        {{ 'Short name' | translate }}
                                        </span>
                                        <span class="ml-auto">
                                            {{ 'Active' | translate }}
                                            <a (click)="toggleOperational()" style="position:relative;top:3px;"
                                                class="fas {{showIconFor()}} toggle__icon ml-2" aria-hidden="true"></a>
                                        </span>
                                        <i class="far fa-copy ml-3 mt-1 copy-btn" tooltip="{{ 'Copy template URL' | translate}}"  (click)="copyUrl()"></i>
                                    </div>
                                    <form class="form-controller">
                                        <input required
                                            class="form-control"
                                            type="text"
                                            name="shortName"
                                            [(ngModel)]="document.shortName"
                                            [rangeLength]="[2, 20]"
                                            #shortName="ngModel"
                                            placeholder="{{'Type a certicate short name' | translate}}"
                                            minlength="2"
                                            maxlength="20"
                                            (change)="saveDocument()"/>
                                    </form>
                                    <p
                                        class="validation-error"
                                        *ngIf="shortName.errors?.required && (shortName?.dirty && shortName?.touched)">
                                        {{ 'form.validate.required' | translate }}
                                        </p>
                                        <p
                                        class="validation-error"
                                        *ngIf="shortName.errors?.rangeLength && (shortName?.dirty && shortName?.touched)">
                                        {{ 'form.validate.minLenght' | translate }} 2!
                                        </p>
                                        <p
                                        class="validation-error"
                                        *ngIf="shortName.errors?.rangeLength && (shortName?.dirty && shortName?.touched)">
                                        {{ 'form.validate.maxLenght' | translate }} 20!
                                        </p>
                                </div>
                            </div>
                            <div class="row fields-group py-2">
                                <div class="col-12">
                                    <div class="list-title mb-0">
                                        <span *ngIf="document.id" class="ml-auto">
                                            {{ 'annexes.doc.isExternal' | translate }}
                                            <a (click)="toggleExternal()" style="position:relative;top:3px;"
                                                class="fas {{showIconForExternal()}} toggle__icon ml-2" aria-hidden="true"></a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="document.isExternal" class="row fields-group mb-0">
                                <div class="col">
                                    <div class="list-title d-flex w-100">
                                        <span *ngIf="document.id && document.isExternal">{{ 'annexes.doc.externalUrl' | translate }}</span>
                                    </div>
                                    <input required class="form-control" type="text" name="documentName" [(ngModel)]="document.externalUrl" #urlMoustachId
                                        placeholder="{{'Type the external url and press enter to submit'|translate}}"
                                        (change)="saveDocument()" #externalUrl/>
                                </div>
                                <div class="col">
                                    <div class="list-title d-flex w-100">&nbsp;</div>
                                    <select class="form-control" [(ngModel)]="selectedTag" (change)="updateUrlWithTag()">
                                        <option value="" disabled>{{ 'annexes.doc.chooseVarInUrl' | translate }}</option>
                                        <option *ngFor="let tag of tags" value="{{tag.key}}">{{tag.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="showFormio" class="certificate-tab-content tab-form {{(activeTab === 'certificate-form' && !document.isExternal) ? 'active-tab': ''}} {{this.store.state.common.lockedPageByUser ? 'locked-page' : ''}}">
                    <div class="page-locker" *ngIf="this.store.state.common.lockedPageByUser"></div>
                    <div class="certificate-tab-inner">
                        <div  class="p-4">
                            <div class="row form-main-actions w-100 preview-button-container-sticky mt-0 py-2 align-content-center" *ngIf="isSchemaLoaded && serviceId && store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel >= 2">
                                <div class="col-sm-12 closer-form">
                                    <form-builder-actions
                                        *ngIf="myFormio"
                                        class="ml-auto mr-2"
                                        [serviceId]="serviceId"
                                        [myFormio]="myFormio"
                                        [formKey]="'applicant-form-sidebar'"
                                        [downloadHandler]="downloadSchema.bind(this)"
                                        [historyHandler]="openHistory.bind(this)"
                                        [historyLabelKey]="'Form history'"
                                        [minUserLevel]="2">
                                    </form-builder-actions>
                                    <span  *ngIf="!hidePreview"
                                        (click)="showPreview()"
                                        class="print-document btn btn-light btn-rounded btn-md text-uppercase align-self-center form-preview-btn">
                                        {{ 'header.preview' | translate }}
                                    </span>
                                </div>
                            </div>
                            <my-formio #myFormio *ngIf="document.id && !document.isExternal && activeTab === 'certificate-form'"
                                    [serviceId]="serviceId"
                                    [focusCompKey]="focusCompKey"
                                    [pasteWithTransformationEnabled]="true"
                                    [pasteWithTransformationIntoCertificate]="true"
                                    [determinantMapById]="determinantMapById"
                                    [formSchema]="document.formSchema" (saveFormSchema)="saveForm($event)" [formName]="document.uniqueName" formType="certificate-form"
                                class="print-forms-builder form-with-preview"></my-formio>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    <app-history-form
        *ngIf="showHistory && document"
        [serviceId]="serviceId"
        [determinantMapById]="determinantMapById"
        [roleId]="document.id"
        [historyController]="printDocController"
        (changeForm)="changeForm($event)"
        (closeLayer)="closeHistory()">
    </app-history-form>


</app-doc-builder>
